import styled from "styled-components";

export const Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
  border-radius: 1px;
  background: rgba(219, 218, 222, 0.1);
  width: 100%;
  height: 1px;
  margin: 0 0 10px;
`;
